import {
  FaHome,
  FaBook,
  FaBuilding,
  FaUsers,
  FaCalendarAlt,
  FaUserTie,
  FaMoneyCheckAlt,
  FaCommentDots,
  FaTags,
  FaBars,
  // FaTasks,
} from "react-icons/fa";
import { useEffect, useState } from "react";
import { RiLogoutCircleRLine } from "react-icons/ri";
// import { MdEditSquare } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import { CgTemplate } from "react-icons/cg";
import { BiSolidConversation } from "react-icons/bi";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { MdAccountBalanceWallet } from "react-icons/md";
import { FaPager } from "react-icons/fa";
import { API_URL } from "../../Config";

const Menubar = ({ isOpen, setIsOpen, isMobile }) => {
  const location = useLocation();
  // const user = JSON.parse(localStorage.getItem("user"));
  const user = JSON.parse(localStorage.getItem("user") || "null") || null;
  const userId = user?.id;

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location.href = "/SignIn";
  };

  useEffect(() => {
    localStorage.setItem("menubarOpen", JSON.stringify(isOpen));
  }, [isOpen]);

  // ── Notification dot ──────────────────────────────────────────────────────
  const [hasNewLeads, setHasNewLeads] = useState(false);

  useEffect(() => {
    const fetchNotifCount = async () => {
      if (!userId) return;
      try {
        const res = await fetch(
          `${API_URL}/lead-notifications?userId=${userId}`,
        );
        const data = await res.json();
        setHasNewLeads((data.total || 0) > 0);
      } catch (e) {
        console.error("Menubar notif fetch failed:", e.message);
      }
    };

    fetchNotifCount();
    const interval = setInterval(fetchNotifCount, 60_000);
    return () => clearInterval(interval);
  }, [userId]);
  // ─────────────────────────────────────────────────────────────────────────
  const menuItems = [
    { icon: <FaHome />, text: "Dashboard", to: "/Dashboard" },
    {
      icon: <BiSolidConversation />,
      text: "Inquire\u00A0Leads",
      to: "/InquireLeads",
      showDot: true, // ← flag this item
    },
    { icon: <FaBook />, text: "Bookings", to: "/Bookings" },
    // { icon: <FaTasks />, text: "Kanban\u00A0Board", to: "/KanbanBoard" },
    { icon: <FaUsers />, text: "Guests\u00A0Records", to: "/GuestRecords" },
    {
      icon: <FaWandMagicSparkles />,
      text: "Smart\u00A0Scheduler",
      to: "/SmartScheduler",
    },
    { icon: <FaBuilding />, text: "Properties", to: "/Properties" },

    { icon: <FaCalendarAlt />, text: "Calendar", to: "/Calendar" },
    {
      icon: <MdAccountBalanceWallet />,
      text: "Accounts",
      to: "/Bills",
    },
    {
      icon: <FaMoneyCheckAlt />,
      text: "Payments\u00A0&\u00A0Invoicing",
      to: "/Payments",
    },
    {
      icon: <FaCommentDots />,
      text: "Reviews\u00A0&\u00A0Feedback",
      to: "/Reviews",
    },
    {
      icon: <CgTemplate />,
      text: "Property\u00A0Brochure",
      to: "/PropertyBrochure",
    },
    {
      icon: <FaPager />,
      text: "Banner\u00A0Elementor",
      to: "/bannerelementor",
    },
    { icon: <FaTags />, text: "Discounts", to: "/Discounts" },
    {
      icon: <FaUserTie />,
      text: "Staff\u00A0Management",
      to: "/StaffManagement",
    },
    { icon: <RiLogoutCircleRLine />, text: "Logout", action: handleLogout },
  ];
  const handleItemClick = () => {
    if (isMobile) {
      setIsOpen(false);
    }
  };

  return (
    <div
      className={`h-screen bg-[#1D2826] text-white transition-all duration-500 fixed top-0 left-0 z-50
        ${isOpen ? (isMobile ? "w-64" : "md:w-64") : "w-[68px]"}
        ${isMobile && !isOpen ? "-translate-x-full" : "translate-x-0"}
      `}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`text-white bg-[#1D2826] p-2 mb-5 rounded
          ${
            isMobile
              ? isOpen
                ? "m-4" // Mobile open
                : "ml-20 mt-4" // Mobile closed
              : "m-4" // Desktop
          } transition-all duration-300`}
      >
        <FaBars size={20} />
      </button>
      {!(isMobile && !isOpen) && (
        <>
          {user && (
            <div className="px-5 mb-6 text-left transition-all duration-500 ease-in-out">
              <p className="font-bold text-white">
                {!isMobile && !isOpen ? (
                  <div className="mb-1.5 w-8 h-8 mx-auto flex items-center justify-center rounded-full border-[1.5px] border-white font-bold text-white">
                    {(user.name || "?").charAt(0).toUpperCase()}
                  </div>
                ) : (
                  <p className="font-bold text-white transition-all ease-in-out duration-500">
                    Hello,&nbsp;{user.name || "there"}
                  </p>
                )}
              </p>

              <p className="text-xs text-gray-400">
                {user.role
                  ? user.role.charAt(0).toUpperCase() +
                    user.role.slice(1).toLowerCase()
                  : ""}
              </p>
            </div>
          )}
          <ul className="left-1/2 space-y-2 overflow-y-auto max-h-[85vh] pb-28 px-4">
            {menuItems.map((item, index) => (
              <li key={index}>
                {item.to ? (
                  <Link
                    to={item.to}
                    onClick={handleItemClick}
                    className={`flex items-center p-2 rounded-md hover:bg-white hover:text-black transition-colors ${
                      location.pathname === item.to ? "bg-white text-black" : ""
                    }`}
                  >
                    {/* Icon wrapper — relative so the dot can anchor to it */}
                    <span className="text-xl relative flex-shrink-0">
                      {item.icon}
                      {item.showDot && hasNewLeads && (
                        <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full" />
                      )}
                    </span>
                    <span
                      className={`text-[15px] ml-4 ${isOpen ? "opacity-100" : "opacity-0 w-0"}`}
                    >
                      {item.text}
                    </span>
                  </Link>
                ) : (
                  <button
                    onClick={item.action}
                    className="flex items-center p-2 rounded-md hover:bg-white hover:text-black transition-colors w-full text-left"
                  >
                    <span className="text-xl">{item.icon}</span>
                    <span
                      className={`text-[15px] ml-4 ${isOpen ? "opacity-100" : "opacity-0 w-0"}`}
                    >
                      {item.text}
                    </span>
                  </button>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default Menubar;
